// Module
var code = "<div ng-if=\"$ctrl.entete.idNature\" ng-include=\"$ctrl.templateUrl\"></div> ";
// Exports
module.exports = code;